export default __webpack_public_path__ + "static/Entenda0062-1760d12f2c6cd0fb43bc42e32c8b08f6.jpg";